<template>
  <v-col lg="4" md="6" sm="6" cols="12">
    <v-card class="reg-details-profile-card partner-info-card" flat tile
      :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
      <v-card-actions>
        <v-card-text>
          <div class="user-wrapper">
            <v-avatar size="92">
              <v-img
                :src="summary?.profile_pic_url || `https://ui-avatars.com/api/?name=${summary?.fullname}&background=random` || require('@/assets/user.png')"></v-img>
            </v-avatar>
            <div class="user-info">
              {{ summary?.fullname }}
              <div class="d-flex align-center">
                <div>
                  <v-img width="24" height="16" :src="flagUrl" :alt="summary?.countries?.name"></v-img>
                </div>
                <span class="ml-1">{{ summary?.countries?.iso_code }}</span>
              </div>
            </div>
          </div>
          <div>
            <v-card-subtitle class="pa-0 mb-2">
              <span class="mdi mdi-email-outline mr-2"></span>
              <span>{{ summary?.email }}</span>
            </v-card-subtitle>
            <v-card-subtitle v-if="summary?.mobile" class="pa-0 mb-2">
              <span class="mdi mdi-phone-in-talk-outline mr-2"></span>
              <span>+{{ summary?.mobile }}</span>
            </v-card-subtitle>
          </div>
        </v-card-text>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'PartnerInfoCard',
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  computed: {
    flagUrl() {
      if (!this.summary?.countries?.iso_code) return '';
      return `https://flagsapi.com/${this.summary.countries.iso_code}/flat/64.png`;
    }
  }
};
</script>